import SettingRow from './SettingRow';

export default SettingRow;
